var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"d-block cursor-pointer mb-0",attrs:{"for":_vm.safeId}},[_c('input',{attrs:{"type":"file","name":"src","hidden":"","id":_vm.safeId,"disabled":_vm.disabled,"multiple":_vm.multiple},on:{"change":function($event){return _vm.onChange($event)}}}),_c('CCard',{staticClass:"m-auto text-center",class:_vm.inpClass,style:({
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
            backgroundColor: _vm.disabled ? '#d8dbe0' : 'inherit'
        })},[_vm._t("card-body-wrapper",function(){return [_c('CCardBody',[_vm._t("card-body")],2)]}),_vm._t("after-card-body")],2),_vm._t("invalid-feedback")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }